<!--
Created on 2021-04-19
Copyright (c) 2021 Vilten s.r.o. - All Rights Reserved
Unauthorized copying of this file, via any medium is strictly prohibited
Proprietary and confidential
Written by Viliam Tencer <vilten@vilten.sk>, 2021-04-19
-->
<template>
  <div id="page">
    <!-- header and footer bar go here-->
    <div class="header header-fixed header-auto-show header-logo-app">
        <a href="#" data-back-button class="header-title header-subtitle">Back</a>
        <a href="#" data-back-button class="header-icon header-icon-1"><i class="fas fa-arrow-left"></i></a>
        <a href="#" data-toggle-theme class="header-icon header-icon-3 show-on-theme-dark"><i class="fas fa-sun"></i></a>
        <a href="#" data-toggle-theme class="header-icon header-icon-3 show-on-theme-light"><i class="fas fa-moon"></i></a>
        <a href="#" data-menu="menu-main" class="header-icon header-icon-2"><i class="fas fa-bars"></i></a>
    </div>
    <footer-bar activeItem="orders" />
    
    <div class="page-content">
        <div class="page-title page-title-small">
            <h2><a href="#" data-back-button><i class="fa fa-arrow-left"></i></a>Objednávky</h2>
            <a href="#" data-menu="menu-main" class="bg-fade-highlight-light shadow-xl preload-img" data-src="images/avatars/5s.png"></a>
        </div>
        <div class="card header-card shape-rounded" data-card-height="150">
            <div class="card-overlay bg-highlight opacity-95"></div>
            <div class="card-overlay dark-mode-tint"></div>
            <div class="card-bg preload-img" data-src="images/pictures/20s.jpg"></div>
        </div>

        <div class="content" style="margin-top: 50px;">
          <div class="row mb-0">
              <router-link to="order-detail" class="col-4">
                  <div class="card card-style text-center py-3 mx-0 mb-0">
                    <i data-feather="plus-circle" data-feather-line="1" data-feather-size="24" data-feather-color="dark-dark" data-feather-bg="gray-fade-light" class="m-auto"></i>
                    <p class="font-13 font-500 mb-n1 mt-2 color-theme">Vytvoriť</p>
                  </div>
              </router-link>
              <a href="#" data-menu="menu-success" class="col-4">
                  <div class="card card-style text-center py-3 mx-0 mb-0">
                    <i data-feather="upload" data-feather-line="1" data-feather-size="24" data-feather-color="dark-dark" data-feather-bg="gray-fade-light" class="m-auto"></i>
                    <p class="font-13 font-500 mb-n1 mt-2 color-theme">Odoslať</p>
                    <div class="badge-number color-white bg-red-dark">2</div>
                  </div>
              </a>
              <router-link to="customers" class="col-4">
                  <div class="card card-style text-center py-3 mx-0 mb-0">
                      <i data-feather="users" data-feather-line="1" data-feather-size="24" data-feather-color="dark-dark" data-feather-bg="gray-fade-light" class="m-auto"></i>
                      <p class="font-13 font-500 mb-n1 mt-2 color-theme">Zákazníci</p>
                  </div>
              </router-link>
          </div>
      </div>

        <div class="card card-style">
          <div class="content">
              <h3 class="font-16">Posledné objednávky</h3>
              <p>
                  Zoznam objednávok zotriedených podľa dátumu vytvorenia a dajú sa filtrovať podľa zákazníka a obdobia.
              </p>
              
              <div data-menu="menu-filters" class="input-style has-borders input-style-always-active no-icon mb-4 pointer">
                  <label for="form5" class="color-black-dark font-500">Filtre</label>
                  <input type="text" class="form-control validate-text bg-white pointer" id="form5" readonly="true" value="Bez filtrov">
                  <span><i class="fa fa-chevron-down"></i></span>
                  <em></em>
              </div>
              
              <div class="input-style has-borders input-style-always-active no-icon mb-4">
                  <label for="form5" class="color-black-dark font-500">Zoradiť</label>
                  <select id="form5" class="bg-white">
                      <option value="1" selected>Od najnovších</option>
                      <option value="2">Od najstarších</option>
                      <option value="2">Podľa sumy 0-9</option>
                      <option value="2">Podľa sumy 9-0</option>
                  </select>
                  <span><i class="fa fa-chevron-down"></i></span>
                  <em></em>
              </div>
              
              <div class="divider mt-3 mb-3"></div>
              <router-link to="order-detail">
                <div class="d-flex">
                  <div>
                    <div class="icon icon-m bg-yellow-dark rounded-m shadow-xl"><i class="fa fa-arrow-up"></i></div>
                  </div>
                  <div class="align-self-center ps-3">
                    <h5 class="font-600 font-14 mb-n1">5104062</h5>
                    <h5 class="font-600 font-14 mb-n1 color-highlight">Vilten s.r.o.</h5>
                    <span class="color-theme font-11">na odoslanie, 4 ks, distr. MED-ART</span>
                  </div>
                  <div class="align-self-center ms-auto">
                    <h6 class="color-highlight mb-0 text-end">12.350 €</h6>
                    <span class="color-theme d-block font-11 text-end">15. júl 2021</span>
                  </div>
                </div>
              </router-link>
              <div class="divider mt-3 mb-3"></div>
              <router-link to="order-detail">
                <div class="d-flex">
                  <div>
                    <div class="icon icon-m bg-blue-light rounded-m shadow-xl"><i class="fa fa-folder-open"></i></div>
                  </div>
                  <div class="align-self-center ps-3">
                    <h5 class="font-600 font-14 mb-n1">5104062</h5>
                    <h5 class="font-600 font-14 mb-n1 color-highlight">SmarterGroup s.r.o.</h5>
                    <span class="color-theme font-11">otvorená, 4 ks, distr. MED-ART</span>
                  </div>
                  <div class="align-self-center ms-auto">
                    <h6 class="color-highlight mb-0 text-end">12.350 €</h6>
                    <span class="color-theme d-block font-11 text-end">15. júl 2021</span>
                  </div>
                </div>
              </router-link>
              <div class="divider mt-3 mb-3"></div>
              <router-link to="order-detail">
                <div class="d-flex">
                  <div>
                    <div class="icon icon-m bg-green-dark rounded-m shadow-xl"><i class="fa fa-euro-sign"></i></div>
                  </div>
                  <div class="align-self-center ps-3">
                    <h5 class="font-600 font-14 mb-n1">5104062</h5>
                    <h5 class="font-600 font-14 mb-n1 color-highlight">ArcGeo s.r.o.</h5>
                    <span class="color-theme font-11">spracovaná, 4 ks, distr. MED-ART</span>
                  </div>
                  <div class="align-self-center ms-auto">
                    <h6 class="color-highlight mb-0 text-end">12.350 €</h6>
                    <span class="color-theme d-block font-11 text-end">15. júl 2021</span>
                  </div>
                </div>
              </router-link>
              <div class="divider mt-3 mb-3"></div>
              <router-link to="order-detail">
                <div class="d-flex">
                  <div>
                    <div class="icon icon-m bg-green-dark rounded-m shadow-xl"><i class="fa fa-euro-sign"></i></div>
                  </div>
                  <div class="align-self-center ps-3">
                    <h5 class="font-600 font-14 mb-n1">5104062</h5>
                    <h5 class="font-600 font-14 mb-n1 color-highlight">ArcGeo s.r.o.</h5>
                    <span class="color-theme font-11">spracovaná, 4 ks, distr. MED-ART</span>
                  </div>
                  <div class="align-self-center ms-auto">
                    <h6 class="color-highlight mb-0 text-end">12.350 €</h6>
                    <span class="color-theme d-block font-11 text-end">15. júl 2021</span>
                  </div>
                </div>
              </router-link>
              <div class="divider mt-3 mb-3"></div>
              <router-link to="order-detail">
                <div class="d-flex">
                  <div>
                    <div class="icon icon-m bg-green-dark rounded-m shadow-xl"><i class="fa fa-euro-sign"></i></div>
                  </div>
                  <div class="align-self-center ps-3">
                    <h5 class="font-600 font-14 mb-n1">5104062</h5>
                    <h5 class="font-600 font-14 mb-n1 color-highlight">ArcGeo s.r.o.</h5>
                    <span class="color-theme font-11">spracovaná, 4 ks, distr. MED-ART</span>
                  </div>
                  <div class="align-self-center ms-auto">
                    <h6 class="color-highlight mb-0 text-end">12.350 €</h6>
                    <span class="color-theme d-block font-11 text-end">15. júl 2021</span>
                  </div>
                </div>
              </router-link>
              <div class="divider mt-3 mb-3"></div>
              <router-link to="order-detail">
                <div class="d-flex">
                  <div>
                    <div class="icon icon-m bg-green-dark rounded-m shadow-xl"><i class="fa fa-euro-sign"></i></div>
                  </div>
                  <div class="align-self-center ps-3">
                    <h5 class="font-600 font-14 mb-n1">5104062</h5>
                    <h5 class="font-600 font-14 mb-n1 color-highlight">ArcGeo s.r.o.</h5>
                    <span class="color-theme font-11">spracovaná, 4 ks, distr. MED-ART</span>
                  </div>
                  <div class="align-self-center ms-auto">
                    <h6 class="color-highlight mb-0 text-end">12.350 €</h6>
                    <span class="color-theme d-block font-11 text-end">15. júl 2021</span>
                  </div>
                </div>
              </router-link>
              <div class="divider mt-3 mb-3"></div>
              <router-link to="order-detail">
                <div class="d-flex">
                  <div>
                    <div class="icon icon-m bg-green-dark rounded-m shadow-xl"><i class="fa fa-euro-sign"></i></div>
                  </div>
                  <div class="align-self-center ps-3">
                    <h5 class="font-600 font-14 mb-n1">5104062</h5>
                    <h5 class="font-600 font-14 mb-n1 color-highlight">ArcGeo s.r.o.</h5>
                    <span class="color-theme font-11">spracovaná, 4 ks, distr. MED-ART</span>
                  </div>
                  <div class="align-self-center ms-auto">
                    <h6 class="color-highlight mb-0 text-end">12.350 €</h6>
                    <span class="color-theme d-block font-11 text-end">15. júl 2021</span>
                  </div>
                </div>
              </router-link>
          </div>
        </div>

        <!-- back to top -->
        <div class="content mt-5 mb-5">
          <a href="#" class="back-to-top-badge bg-highlight shadow-xl"><i class="fa fa-caret-up"></i><span>Back to Top</span></a>
        </div>
            
        <!-- footer and footer card-->
        <footer-card class="footer" />
    </div>    
    <!-- end of page content-->
    <div class="scroll-button">
      <div>
        <a href="#" class="back-to-top-badge rounded-xs back-to-top-icon-circle bg-highlight shadow-m"><i class="fa fa-angle-up p-0 m-n2"></i></a>
      </div>
    </div>
    
    <!-- modal customer select -->
    <div id="menu-customer-select" class="menu menu-box-modal rounded-m p-3" 
      data-menu-height="380" 
      data-menu-width="310">
      <h1 class="text-center font-700">Vyber zákazníka</h1>
      <div data-menu="menu-customer-select" class="input-style has-borders input-style-always-active no-icon mb-4">
        <label for="form5" class="color-black-dark font-500">Filter</label>
        <input type="text" class="form-control validate-text bg-white" id="form5">
        <span><i class="fa fa-search"></i></span>
        <span style="display: none"><i class="fa fa-times"></i></span>
        <em></em>
      </div>
      <div style="overflow-x: none; overflow-y: scroll; max-height: 225px;">
        <div class="close-menu">
          <div class="divider mt-1 mb-1"></div>
          <div class="p-2">Všetci</div>
        </div>
        <div class="close-menu">
          <div class="divider mt-1 mb-1"></div>
          <div class="p-2">Bratislava</div>
        </div>
        <div class="close-menu">
          <div class="divider mt-1 mb-1"></div>
          <div class="p-2">Bernolákovo</div>
        </div>
        <div class="close-menu">
          <div class="divider mt-1 mb-1"></div>
          <div class="p-2">Adamovo</div>
        </div>
        <div class="close-menu">
          <div class="divider mt-1 mb-1"></div>
          <div class="p-2">Bratislava</div>
        </div>
        <div class="close-menu">
          <div class="divider mt-1 mb-1"></div>
          <div class="p-2">Bernolákovo</div>
        </div>
        <div class="close-menu">
          <div class="divider mt-1 mb-1"></div>
          <div class="p-2">Adamovo</div>
        </div>
        <div class="close-menu">
          <div class="divider mt-1 mb-1"></div>
          <div class="p-2">Bratislava</div>
        </div>
        <div class="close-menu">
          <div class="divider mt-1 mb-1"></div>
          <div class="p-2">Bernolákovo</div>
        </div>
        <div class="close-menu">
          <div class="divider mt-1 mb-1"></div>
          <div class="p-2">Adamovo</div>
        </div>
        <div class="close-menu">
          <div class="divider mt-1 mb-1"></div>
          <div class="p-2">Bratislava</div>
        </div>
        <div class="close-menu">
          <div class="divider mt-1 mb-1"></div>
          <div class="p-2">Bernolákovo</div>
        </div>
        <div class="close-menu">
          <div class="divider mt-1 mb-1"></div>
          <div class="p-2">Adamovo</div>
        </div>
        <div class="close-menu">
          <div class="divider mt-1 mb-1"></div>
          <div class="p-2">Bratislava</div>
        </div>
        <div class="close-menu">
          <div class="divider mt-1 mb-1"></div>
          <div class="p-2">Bernolákovo</div>
        </div>
        <div class="close-menu">
          <div class="divider mt-1 mb-1"></div>
          <div class="p-2">Adamovo</div>
        </div>
        <div class="close-menu">
          <div class="divider mt-1 mb-1"></div>
          <div class="p-2">Bratislava</div>
        </div>
        <div class="close-menu">
          <div class="divider mt-1 mb-1"></div>
          <div class="p-2">Bernolákovo</div>
        </div>
        <div class="close-menu">
          <div class="divider mt-1 mb-1"></div>
          <div class="p-2">Adamovo</div>
        </div>
        <div class="close-menu">
          <div class="divider mt-1 mb-1"></div>
          <div class="p-2">Bratislava</div>
        </div>
        <div class="close-menu">
          <div class="divider mt-1 mb-1"></div>
          <div class="p-2">Bernolákovo</div>
        </div>
        <div class="close-menu">
          <div class="divider mt-1 mb-1"></div>
          <div class="p-2">Adamovo</div>
        </div>
        <div class="close-menu">
          <div class="divider mt-1 mb-1"></div>
          <div class="p-2">Bratislava</div>
        </div>
        <div class="close-menu">
          <div class="divider mt-1 mb-1"></div>
          <div class="p-2">Bernolákovo</div>
        </div>
        <div class="close-menu">
          <div class="divider mt-1 mb-1"></div>
          <div class="p-2">Adamovo</div>
        </div>
        <div class="close-menu">
          <div class="divider mt-1 mb-1"></div>
          <div class="p-2">Bratislava</div>
        </div>
        <div class="close-menu">
          <div class="divider mt-1 mb-1"></div>
          <div class="p-2">Bernolákovo</div>
        </div>
        <div class="close-menu">
          <div class="divider mt-1 mb-1"></div>
          <div class="p-2">Adamovo</div>
        </div>
        <div class="close-menu">
          <div class="divider mt-1 mb-1"></div>
          <div class="p-2">Bratislava</div>
        </div>
        <div class="close-menu">
          <div class="divider mt-1 mb-1"></div>
          <div class="p-2">Bernolákovo</div>
        </div>
        <div class="close-menu">
          <div class="divider mt-1 mb-1"></div>
          <div class="p-2">Adamovo</div>
        </div>
        <div class="close-menu">
          <div class="divider mt-1 mb-1"></div>
          <div class="p-2">Bratislava</div>
        </div>
        <div class="close-menu">
          <div class="divider mt-1 mb-1"></div>
          <div class="p-2">Bernolákovo</div>
        </div>
        <div class="close-menu">
          <div class="divider mt-1 mb-1"></div>
          <div class="p-2">Adamovo</div>
        </div>
        <div class="close-menu">
          <div class="divider mt-1 mb-1"></div>
          <div class="p-2">Bratislava</div>
        </div>
        <div class="close-menu">
          <div class="divider mt-1 mb-1"></div>
          <div class="p-2">Bernolákovo</div>
        </div>
        <div class="close-menu">
          <div class="divider mt-1 mb-1"></div>
          <div class="p-2">Adamovo</div>
        </div>
        <div class="close-menu">
          <div class="divider mt-1 mb-1"></div>
          <div class="p-2">Bratislava</div>
        </div>
        <div class="close-menu">
          <div class="divider mt-1 mb-1"></div>
          <div class="p-2">Bernolákovo</div>
        </div>
        <div class="close-menu">
          <div class="divider mt-1 mb-1"></div>
          <div class="p-2">Adamovo</div>
        </div>
        <div class="close-menu">
          <div class="divider mt-1 mb-1"></div>
          <div class="p-2">Bratislava</div>
        </div>
        <div class="close-menu">
          <div class="divider mt-1 mb-1"></div>
          <div class="p-2">Bernolákovo</div>
        </div>
        <div class="close-menu">
          <div class="divider mt-1 mb-1"></div>
          <div class="p-2">Adamovo</div>
        </div>
        <div class="close-menu">
          <div class="divider mt-1 mb-1"></div>
          <div class="p-2">Bratislava</div>
        </div>
        <div class="close-menu">
          <div class="divider mt-1 mb-1"></div>
          <div class="p-2">Bernolákovo</div>
        </div>
        <div class="close-menu">
          <div class="divider mt-1 mb-1"></div>
          <div class="p-2">Adamovo</div>
        </div>
      </div>
    </div>

    <!-- modal distributor select -->
    <div id="menu-dist-select" class="menu menu-box-modal rounded-m p-3" 
      data-menu-height="390" 
      data-menu-width="310">
      <h1 class="text-center font-700">Vyber distribútora</h1>
      <div data-menu="menu-dist-select" class="input-style has-borders input-style-always-active no-icon mb-4">
        <label for="form5" class="color-black-dark font-500">Filter</label>
        <input type="text" class="form-control validate-text bg-white" id="form5">
        <span><i class="fa fa-search"></i></span>
        <span style="display: none"><i class="fa fa-times"></i></span>
        <em></em>
      </div>
      <div style="overflow-x: none; overflow-y: scroll; max-height: 235px;">
        <div class="close-menu">
          <div class="divider mt-1 mb-1"></div>
          <div class="p-2">Všetci</div>
        </div>
        <div class="close-menu">
          <div class="divider mt-1 mb-1"></div>
          <div class="p-2">MED-ART</div>
        </div>
        <div class="close-menu">
          <div class="divider mt-1 mb-1"></div>
          <div class="p-2">PHOENIX</div>
        </div>
        <div class="close-menu">
          <div class="divider mt-1 mb-1"></div>
          <div class="p-2">UNIMED</div>
        </div>
        <div class="close-menu">
          <div class="divider mt-1 mb-1"></div>
          <div class="p-2">UNIPHARMA</div>
        </div>
      </div>
    </div>

    <main-menu />

    <dr-theiss-page-modal />

    <!-- modal filters -->
    <div id="menu-filters" class="menu menu-box-bottom menu-box-detached rounded-m" 
         data-menu-height="430" 
         data-menu-effect="menu-paralax">
        <div class="content mb-0">
            <h1 class="font-700 mb-0">Filtre</h1>
            <p class="font-11 mt-n1 mb-n2">
                Tu si môžete pozapínať filtrovanie zoznamu objednávok.
            </p>

            <div class="d-flex no-effect mb-2" 
                  data-trigger-switch="toggle-id-1" 
                  data-bs-toggle="collapse" 
                  href="#" 
                  role="button" 
                  aria-expanded="false" 
                  aria-controls="collapseExample1">
                <div class="pt-2 mt-1">
                    <h5 class="font-600 font-14">Moje objednávky</h5>
                </div>
                <div class="ms-auto me-4 pe-2">
                    <div class="custom-control ios-switch" style="margin-top: 12px !important;">
                        <input type="checkbox" class="ios-input" id="toggle-id-1">
                        <label class="custom-control-label" for="toggle-id-1"></label>
                    </div>
                </div>
            </div>
            <div data-menu="menu-customer-select" class="input-style has-borders input-style-always-active no-icon mb-4 pointer">
              <label for="form5" class="color-black-dark font-500">Zákazníci</label>
              <input type="text" class="form-control validate-text bg-white pointer" id="form5" readonly="true" value="Všetci">
              <span><i class="fa fa-chevron-down"></i></span>
              <em></em>
            </div>
            <div data-menu="menu-dist-select" class="input-style has-borders input-style-always-active no-icon mb-4 pointer">
              <label for="form5" class="color-black-dark font-500">Distribútori</label>
              <input type="text" class="form-control validate-text bg-white pointer" id="form5" readonly="true" value="Všetci">
              <span><i class="fa fa-chevron-down"></i></span>
              <em></em>
            </div>
            <div class="input-style has-borders input-style-always-active no-icon mb-4">
              <label for="form5" class="color-black-dark font-500">Časové obdobie</label>
              <select id="form5" class="bg-white">
                  <option value="1" selected>Tento týždeň</option>
                  <option value="2">Tento mesiac</option>
                  <option value="2">Tento rok</option>
                  <option value="2">Posledných 30 dní</option>
                  <option value="2">Posledných 365 dní</option>
              </select>
              <span><i class="fa fa-chevron-down"></i></span>
              <em></em>
            </div>
            <div class="mb-3">
              <a href="#" data-menu="menu-forgot" class="font-10">Vypnúť filtre</a>
            </div>
            <a href="#" class="btn close-menu btn-full btn-m shadow-l rounded-s text-uppercase font-900 bg-green-dark">filtrovať</a>
        </div>
    </div>     
  </div>    
</template>

<script>
import FooterBar from '@/components/bars/FooterBar'
import MainMenu from '@/components/menus/MainMenu'
import DrTheissPageModal from '@/components/modals/DrTheissPageModal'
import FooterCard from '@/components/cards/FooterCard'

export default {
  name: 'Orders',
  components: {
    MainMenu,
    FooterCard,
    DrTheissPageModal,
    FooterBar,
  },
  setup() {
    return {

    }
  },
  mounted() {
    setTimeout(() => {
      document.init_event()
    })
  },
}
</script>
